<template>
    <div>
      <slot></slot>
    </div>
</template>

<script>
export default {
  name: 'WarningText'
}
</script>

<style scoped>
div{
    width: 100%;
    text-align: center;
    color: #d0021b;
}
</style>
